import React, { useEffect, useRef, useState } from "react";
// import { postData } from "../../api/api";
import { API_BASE_URL } from "../../configs/variable.config";
// import useFormStore from "../../store/formData";
import gallery from "../../assets/image/gallery.png";
import camera from "../../assets/image/camera.png";

const ImageInput = (props) => {
  const [modalState, setModalState] = useState(false);
  const fileInputRefCamera = useRef(null);
  const fileInputRefGallery = useRef(null);

  // useEffect(() => {
  //     formData[props.id] && setImageSrc(formData[props.id])
  // }, [])

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      getUuid(file);
    }
  };

  async function getUuid(file) {
    const formData = new FormData();
    formData.append("file", file); // 'image' به عنوان نام فیلد ارسال می‌شود
    try {
      const response = await fetch(
        `http://127.0.0.1:8000/api/v1/panel/expert/files`,
        {
          method: "POST",
          body: formData,
        },
      );
      if (response.ok) {
        const data = await response.json();
        props.onChangeHandler(props.id, data.data.id);
      } else {
        console.error("Upload failed");
      }
    } catch (error) {
      console.error("Error sending file:", error);
    }
  }

  const handleGalleryClick = () => {
    if (fileInputRefGallery.current) {
      fileInputRefGallery.current.click(); // کلیک کردن روی ورودی فایل مخفی
      setModalState(false);
    }
  };
  const handleCameraClick = () => {
    if (fileInputRefCamera.current) {
      fileInputRefCamera.current.click(); // کلیک کردن روی ورودی فایل مخفی
      setModalState(false);
    }
  };

  return (
    <div
      className={`relative w-full flex flex-col ${props.name && "border-b"} pb-2 gap-2`}
    >
      <div className={"flex flex-col"}>
        {props.name && <span className="text-sm">{props.name}</span>}
        {props.imageSrc && (
          <a
            href={`http://127.0.0.1:8000/api/v1/panel/expert/files/${props.imageSrc}`}
            download
            className="flex items-center gap-1 self-center text-blue-600 hover:text-blue-800 transition-colors text-sm mt-1 mb-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-9-12v12m0 0l-3.75-3.75M12 16.5l3.75-3.75"
              />
            </svg>
            <span className={"inline-block mt-1"}>دانلود عکس</span>
          </a>
        )}
      </div>
      <div
        className="border border-dashed border-[#B0B0B0] rounded-xl w-full min-h-28 overflow-hidden self-end flex items-center justify-center text-[#B0B0B0]"
        onClick={() => {
          setModalState(true);
        }}
      >
        {props.imageSrc && !props.noPhotoDisplay ? (
          <img
            src={
              "http://127.0.0.1:8000/api/v1/panel/expert/files/" +
              props.imageSrc
            }
            alt="Uploaded"
            className="w-full h-auto"
          />
        ) : (
          <div className="flex flex-col gap-2 items-center justify-center h-full w-full">
            <i className="i-gallery-add text-5xl" />
            <span className="text-xs">افزودن عکس</span>
          </div>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleImageChange}
        ref={fileInputRefCamera}
        className="hidden"
      />
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        ref={fileInputRefGallery}
        className="hidden"
      />
      {modalState && (
        <div
          className="bg-[#0000005b] fixed bottom-0 right-0 z-[1000] w-screen h-screen flex items-end"
          onClick={() => {
            setModalState(false);
          }}
        >
          <div
            className="w-full bg-white shadow-card1 p-10 justify-around flex items-center rounded-t-2xl"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div
              className="flex items-center flex-col gap-2"
              onClick={handleGalleryClick}
            >
              <img className="w-12 h-auto" src={gallery} />
              <span>گالری</span>
            </div>
            <div
              className="flex items-center flex-col gap-2"
              onClick={handleCameraClick}
            >
              <img className="w-12 h-auto" src={camera} />
              <span>دوربین</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageInput;
